export default __webpack_public_path__ + "static/private-sp-09d2baeb382417f2cf7190091a6cde26.png";